module.exports = __webpack_public_path__ + "static/img/choose-icon.9ec00c6.jpg";